export default __webpack_public_path__ + "static/media/refund.bc76f1d8.svg";